import { Col, Flex, Modal, Row } from 'antd'
import { FormInstance } from 'antd/lib'

import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  form?: FormInstance
  productIndex: number
  onCancel: () => void
}

export const InputConsumablesModal = ({
  form,
  productIndex,
  onCancel
}: Props) => {
  const { t } = useLocales()

  const medicine = form?.getFieldValue(['medicine', productIndex])

  if (!medicine) {
    onCancel()
    return null
  }

  return (
    <Modal
      open
      maskClosable={false}
      centered
      title={t('stock_administration.product_details')}
      width={800}
      onCancel={onCancel}
      footer={false}
    >
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.commercial_naming')}
            </Text>
            <Text>{medicine?.name ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.group')}
            </Text>
            <Text>{medicine?.group ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('medicine_register.products.dose')}
            </Text>
            <Text>{medicine?.dose ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('stock_administration.entry_form')}
            </Text>
            <Text>{medicine?.form?.name ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.tva')}
            </Text>
            <Text>{medicine?.tvaUnitRateName ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('stock_administration.unit_price_with_tva')}
            </Text>
            <Text>{medicine?.tvaTotal ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.measure_unit')}
            </Text>
            <Text>{medicine?.measurementUnitName ?? '-'}</Text>
          </Flex>
        </Col>

        <Col span={12}>
          <Flex gap={4} vertical>
            <Text weight={600} size="lg">
              {t('common.producer')}
            </Text>
            <Text>{medicine?.producerName ?? '-'}</Text>
          </Flex>
        </Col>
      </Row>
    </Modal>
  )
}
